import { useLanguage } from "@/contexts/language-context"

export interface CommunicationOption {
  id: string
  label: string
}

export function useCommunicationOptions() {
  const { t } = useLanguage()

  const scenarios: CommunicationOption[] = [
    { id: "none", label: t("dropdown.scenario") },
    { id: "email", label: t("scenario.email") },
    { id: "message", label: t("scenario.message") },
    { id: "workplace", label: t("scenario.workplace") },
    { id: "school", label: t("scenario.school") },
    { id: "home", label: t("scenario.home") },
    { id: "business", label: t("scenario.business") },
    { id: "academic", label: t("scenario.academic") },
    { id: "social", label: t("scenario.social") },
    { id: "formal", label: t("scenario.formal") },
    { id: "casual", label: t("scenario.casual") },
    { id: "professional", label: t("scenario.professional") },
    { id: "personal", label: t("scenario.personal") },
    { id: "customer-service", label: t("scenario.customerService") },
    { id: "interview", label: t("scenario.interview") },
    { id: "presentation", label: t("scenario.presentation") },
  ]

  const targets: CommunicationOption[] = [
    { id: "none", label: t("dropdown.target") },
    { id: "lover", label: t("target.lover") },
    { id: "friend", label: t("target.friend") },
    { id: "boss", label: t("target.boss") },
    { id: "colleague", label: t("target.colleague") },
    { id: "classmate", label: t("target.classmate") },
    { id: "parents", label: t("target.parents") },
    { id: "child", label: t("target.child") },
    { id: "teacher", label: t("target.teacher") },
    { id: "student", label: t("target.student") },
    { id: "client", label: t("target.client") },
    { id: "customer", label: t("target.customer") },
    { id: "stranger", label: t("target.stranger") },
    { id: "family", label: t("target.family") },
    { id: "sibling", label: t("target.sibling") },
    { id: "neighbor", label: t("target.neighbor") },
    { id: "mentor", label: t("target.mentor") },
    { id: "supplier", label: t("target.supplier") },
    { id: "service-provider", label: t("target.serviceProvider") },
    { id: "partner", label: t("target.partner") },
    { id: "subordinate", label: t("target.subordinate") },
  ]

  const tones: CommunicationOption[] = [
    { id: "none", label: t("dropdown.tone") },
    { id: "humorous", label: t("tone.humorous") },
    { id: "serious", label: t("tone.serious") },
    { id: "happy", label: t("tone.happy") },
    { id: "angry", label: t("tone.angry") },
    { id: "mischievous", label: t("tone.mischievous") },
    { id: "polite", label: t("tone.polite") },
    { id: "casual", label: t("tone.casual") },
    { id: "formal", label: t("tone.formal") },
    { id: "friendly", label: t("tone.friendly") },
    { id: "confident", label: t("tone.confident") },
    { id: "apologetic", label: t("tone.apologetic") },
    { id: "enthusiastic", label: t("tone.enthusiastic") },
  ]

  // 辅助函数：根据ID获取标签
  const getScenarioLabel = (id: string): string => {
    const scenario = scenarios.find(s => s.id === id)
    return scenario ? scenario.label : id.charAt(0).toUpperCase() + id.slice(1)
  }

  const getTargetLabel = (id: string): string => {
    const target = targets.find(t => t.id === id)
    return target ? target.label : id.charAt(0).toUpperCase() + id.slice(1)
  }

  const getToneLabel = (id: string): string => {
    const tone = tones.find(t => t.id === id)
    return tone ? tone.label : id.charAt(0).toUpperCase() + id.slice(1)
  }

  return {
    scenarios,
    targets,
    tones,
    getScenarioLabel,
    getTargetLabel,
    getToneLabel
  }
} 